const $hiddenContent = document.querySelectorAll('.js-hidden-content');

$hiddenContent.forEach($el => {
    $el.addEventListener('click', e => {
        requestAnimationFrame(() => (
            $el.classList.add('js-hidden-content_active')
        ))
    })
});